const fr = {
  translation: {
    button_join_room: "Rejoindre la partie",
    button_create_room: "Créer une partie",
    button_ready: "Pret !",
    button_cancel: "Annuler",
    button_start: "Commencer",
    button_deal: "RIEN",
    button_set: "SET !",
    button_play_again: "Rejouer",
    label_buzz: "BUZZ",
    label_start: "PRET",
    label_deal: "PIOCHE",
    cards_left: "Pioche",
    placeholder_username: "Pseudo",
    lobby_header: "En attente d'autres joueurs",
    lobby_text:
      "Invite tes amis à rejoindre la partie en leur envoyant le lien.",
    score_board_header: "Joueurs",

    game_over: "GAME OVER",

    rules_main_header: "RÈGLES",
  },
};

export default fr;
